// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active + a > div > div {
  border-radius: 0px 12px 0px 0px;
}

a:has(+ .active) > div > div {
  border-radius: 0px 0px 12px 0px;
}

.active + div {
  border-radius: 0px 12px 0px 0px;
}

/* Mention text styles */

.m6zwb4v,
.m6zwb4v:visited {
  color: var(--color-info-400);
  cursor: pointer;
  display: inline-block;
  padding-left: 2px;
  padding-right: 2px;
  border-radius: 2px;
  -webkit-text-decoration: none;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.m6zwb4v::before {
  content: '@';
}

.m6zwb4v:hover,
.m6zwb4v:focus {
  color: var(--color-neutral-600);
  background: var(--color-secondary-100);
  outline: 0;
}

.mnw6qvm {
  border: 1px solid var(--color-neutral-300);
  position: absolute;
  min-width: 220px;
  max-width: 440px;
  background: var(--color-neutral-100);
  border-radius: 2px;
  box-shadow: 0px 4px 30px 0px;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  transform: scale(0);
}

.m1ymsnxd {
  opacity: 0;
  transition: opacity 0.25s cubic-bezier(0.3, 1.2, 0.2, 1);
}

.m126ak5t {
  opacity: 1;
}

.mtiwdxc {
  padding: 7px 10px 3px 10px;
  transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);
}

.mtiwdxc:active {
  background-color: var(--color-secondary-200);
}

.myz2dw1 {
  padding: 7px 10px 3px 10px;
  transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);
  background-color: var(--color-secondary-200);
}

.myz2dw1:active {
  background-color: var(--color-secondary-200);
}

.mpqdcgq {
  display: inline-block;
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 368px;
  font-size: 0.9em;
  margin-bottom: 0.2em;
}

.m1mfvffo {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/style.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wBAAwB;;AAExB;;EAEE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,6BAAqB;EAArB,qBAAqB;AACvB;;AACA;EACE,YAAY;AACd;;AACA;;EAEE,+BAA+B;EAC/B,sCAAsC;EACtC,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EAIV,aAAa;EAGb,sBAAsB;EACtB,sBAAsB;EAGtB,mBAAmB;AACrB;;AACA;EACE,UAAU;EAEV,wDAAwD;AAC1D;;AACA;EACE,UAAU;AACZ;;AACA;EACE,0BAA0B;EAE1B,sEAAsE;AACxE;;AACA;EACE,4CAA4C;AAC9C;;AACA;EACE,0BAA0B;EAE1B,sEAAsE;EACtE,4CAA4C;AAC9C;;AACA;EACE,4CAA4C;AAC9C;;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".active + a > div > div {\n  border-radius: 0px 12px 0px 0px;\n}\n\na:has(+ .active) > div > div {\n  border-radius: 0px 0px 12px 0px;\n}\n\n.active + div {\n  border-radius: 0px 12px 0px 0px;\n}\n\n/* Mention text styles */\n\n.m6zwb4v,\n.m6zwb4v:visited {\n  color: var(--color-info-400);\n  cursor: pointer;\n  display: inline-block;\n  padding-left: 2px;\n  padding-right: 2px;\n  border-radius: 2px;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n.m6zwb4v::before {\n  content: '@';\n}\n.m6zwb4v:hover,\n.m6zwb4v:focus {\n  color: var(--color-neutral-600);\n  background: var(--color-secondary-100);\n  outline: 0;\n}\n\n.mnw6qvm {\n  border: 1px solid var(--color-neutral-300);\n  position: absolute;\n  min-width: 220px;\n  max-width: 440px;\n  background: var(--color-neutral-100);\n  border-radius: 2px;\n  box-shadow: 0px 4px 30px 0px;\n  cursor: pointer;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  z-index: 2;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  box-sizing: border-box;\n  -webkit-transform: scale(0);\n  -ms-transform: scale(0);\n  transform: scale(0);\n}\n.m1ymsnxd {\n  opacity: 0;\n  -webkit-transition: opacity 0.25s cubic-bezier(0.3, 1.2, 0.2, 1);\n  transition: opacity 0.25s cubic-bezier(0.3, 1.2, 0.2, 1);\n}\n.m126ak5t {\n  opacity: 1;\n}\n.mtiwdxc {\n  padding: 7px 10px 3px 10px;\n  -webkit-transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);\n  transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);\n}\n.mtiwdxc:active {\n  background-color: var(--color-secondary-200);\n}\n.myz2dw1 {\n  padding: 7px 10px 3px 10px;\n  -webkit-transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);\n  transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);\n  background-color: var(--color-secondary-200);\n}\n.myz2dw1:active {\n  background-color: var(--color-secondary-200);\n}\n.mpqdcgq {\n  display: inline-block;\n  margin-left: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 368px;\n  font-size: 0.9em;\n  margin-bottom: 0.2em;\n}\n.m1mfvffo {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
